import { createContext, useCallback, useContext, useState } from 'react'
import CommonSnackbar from '../components/common/CommonSnackbar'

const SnackbarContext = createContext()

export const useSnackbar = () => useContext(SnackbarContext)

const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
    anchorOrigin: { vertical: 'top', horizontal: 'right' },
    autoHideDuration: 3000,
  })

  const showSnackbar = useCallback(
    (message, severity = 'success', anchorOrigin, autoHideDuration) => {
      setSnackbar({
        open: true,
        message,
        severity,
        anchorOrigin,
        autoHideDuration,
      })
    },
    []
  )

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <CommonSnackbar
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        autoHideDuration={snackbar.autoHideDuration}
        severity={snackbar.severity}
        anchorOrigin={snackbar.anchorOrigin}
      />
    </SnackbarContext.Provider>
  )
}

export default SnackbarProvider
